<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    :persistent="persistent"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @click:outside="$emit('click:outside')"
  >
    <v-card>
      <slot></slot>
      <v-card-title v-if="hasTitleSlot">
        <v-row justify="center" class="modal-title">
          <slot name="title"></slot>
        </v-row>
      </v-card-title>
      <v-card-text v-if="hasContentSlot" class="black--text">
        <slot name="content"></slot>
      </v-card-text>
      <v-card-actions v-if="hasActionSlot" class="pb-4 pr-4">
        <v-spacer />
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Modal',
  inheritAttrs: false,
  props: {
    maxWidth: {
      type: [String, Number],
      default: null,
    },
    persistent: {
      type: [String, Boolean],
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'click:outside'],
  computed: {
    hasTitleSlot() {
      return !!this.$slots.title;
    },
    hasContentSlot() {
      return !!this.$slots.content;
    },
    hasActionSlot() {
      return !!this.$slots.actions;
    },
  },
};
</script>

<style scoped>
.modal-title {
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: 29px;
  letter-spacing: 0em;
}
</style>
